import { Dispatch } from 'react-redux';
import { AuthActionCreators, IAddressValidationResponse, IApplicationState } from "../";
import { IBaseResponse, IConnectToDonorStatus, IDashRegistrationLog, IDonorConnect, IDonorConnectUser, IListItem, IDonorConnectCounts, ICenterBase, IMicrositeRecipient, IDonorConnectCenterContacts } from '@nkr/models/index';
import { SurveyType, ConnectToDonorMilestone } from '@nkr/enums/index';
import { IPost, IDelete, IGet } from '../authorization/actions';

import { ActionCreators as ActionCreatorsIlda, IIldaListResponse, IIldaCountResponse, IIldaLogListResponse, IIldaLogResponse, IIldaLookupDataResponse, IIldaRegistrationResponse, IIldaUploadedFilesListResponse, IIldaUserListResponse } from './actions-ilda';
import { ActionCreators as ActionCreatorsReports, IDonorConnectCompletionsReportResponse, IDonorConnectMentorPerformanceResponse, IMentorCompletionsListResponse } from './actions-reports';
import { ActionCreators as ActionCreatorsLanguage, IVariableReportListResponse, IVariableReportLookUpResponse, IVariableTextResponse } from './actions-language';
import { ActionCreators as ActionCreatorsSelfServeReconciliation, IDashSelfServeReconciliationCreateResponse, IDashSelfServeReconciliationProcessResponse, IDashSelfServeReconciliationUploadResponse } from './actions-self-serve-reconciliation';
import { ActionCreators as ActionCreatorsDonorConnectIncidenReports, IIncidentReportListResponse, IIncidentReportResponse, IIncidentReportLogResponse, IIncidentReportLookUpResponse } from './actions-donor-connect-incident-reports';
import { IDashCenterLookupDataResponse } from '../donor-intake/actions';
import { ICounselor } from '@nkr/views/dash/donor-connect/models';

export const ActionTypes = {}

export interface IDonorConnectListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            list: IDonorConnect[],
            counts: IDonorConnectCounts
        }
    }
}

export interface IDonnorConnectLogListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDashRegistrationLog[]
    }
}

export interface IDonnorConnectLogResponse {
    data: {
        success: boolean,
        message: string,
        results: IDashRegistrationLog
    }
}

export interface IDonorConnectLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            statusList: IConnectToDonorStatus[],
            actionList: IListItem[],
            mentorEducationChoiceList: IListItem[],
            voucherEducationChoiceList: IListItem[],
            userList: ICounselor[],
            centerList: ICenterBase[],
            closeLoopDonationTypes: IListItem[],
            micrositeRecipientList: IMicrositeRecipient[]
        }
    }
}

export interface IDonorConnectUserListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnectUser[]
    }
}

export interface IDonorConnectNextMilestoneResponse {
    data: {
        success: boolean,
        results: {
            connectToDonorMilestone: ConnectToDonorMilestone,
            connectToDonorMilestoneDescription: string,
            connectToDonorNextMilestone: ConnectToDonorMilestone,
            connectToDonorNextMilestoneDescription: string,
            connectToDonorMilestoneCanProgress: boolean
        }
    }
}

export interface IFindForTransferResponse {
    data: {
        success: boolean,
        message: string,
        results: { id: number, donorConnectAlreadyAssigned: boolean }[]
    }
}

export interface ITransferResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnect
    }
}

export interface IDuplicateListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnect[]
    }
}

export interface IDuplicateListMentorChangeResponse {
    data: {
        success: boolean,
        results: string[]
    }
}

export interface ICenterContactsResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnectCenterContacts[]
    }
}


export interface IMailingAddress {
    streetAddress: string,
    city: string,
    state: string,
    zip5: string,
    zip4: string,
    cityStateZip: string
}

export const ActionCreatorsMain = {
    getDonorConnectList: (listType: number, counselorFilter: number, statusFilter: number, showFilter: number, micrositeRecipientId: number, searchFilter: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/registrations?listType=${listType}&counselor=${counselorFilter}&status=${statusFilter}&show=${showFilter}&micrositeRecipientId=${micrositeRecipientId}&search=${searchFilter}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getDonorConnectLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectLookupDataResponse> => {
        let options = {
            url: `${__API__}/donor-connect/lookup-data`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getDonorConnectLogEntries: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonnorConnectLogListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/registration/${id}/logs`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    changeStatus: (id: number, status: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/change-status/${status}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    changeMentorEducationChoice: (id: number, choice: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/change-mentor-education-choice/${choice}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    changedAssignedCounselor: (id: number, userId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/assigned-counselor/${userId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    changedAssignedCounselorBatch: (list: { id: number, userId: number }[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IDuplicateListMentorChangeResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/assigned-counselor-batch`,
            data: list
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    unassignCounselor: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/unassign-counselor`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    updateNextFollowUpDate: (id: number, date: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/next-followup-date?date=${date}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    updateDonationDate: (id: number, date: string, type: string, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/update-donation-date?date=${date}&type=${type}&centerId=${centerId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    updateMilestone: (id: number, milestone: ConnectToDonorMilestone) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectNextMilestoneResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/next-milestone/${milestone}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    submitSurvey: (registrationId: number, treatment: number, convenience: number, facility: number, surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string, surveyType: SurveyType) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectNextMilestoneResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/survey`,
            data: {
                surveyType,
                registrationId,
                treatment,
                convenience,
                facility,
                surgeonCare,
                nurseCare,
                painCare,
                caretakerTreatment,
                financialBurden,
                donationCost,
                commendation,
                improvement,
                completedDate
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    saveLogEntry: (id: number, dashRegistrationId: number, actionTakenId: number, comments: string, isPinned: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonnorConnectLogResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/log-entry`,
            data: {
                id,
                dashRegistrationId,
                actionTakenId,
                comments,
                isPinned
            }
        };

        try {
            if (id == 0)
                return await dispatch(AuthActionCreators.apiPost(options));
            else
                return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
    deleteLogEntry: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IDelete = {
            url: `${__API__}/donor-connect/log-entry/${id}`
        };

        try {
            return await dispatch(AuthActionCreators.apiDelete(options));
        } catch (error) {
            throw error;
        }
    },
    getDonorConnectUsers: () => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectUserListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/users`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    updateDonorConnectCaseLoad: (userId: number, donorConnectCaseLoad: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor-connect/case-load`,
            data: {
                userId,
                donorConnectCaseLoad
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    findForDonorConnectTransfer: (centerId: number, email: string, birthDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IFindForTransferResponse> => {
        let options = {
            url: `${__API__}/donor-connect/find-for-transfer`,
            data: {
                centerId,
                email,
                birthDate
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    transferDonorConnectToExistingRegistration: (transferFromId: number, transferToId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ITransferResponse> => {
        let options = {
            url: `${__API__}/donor-connect/${transferFromId}/transfer-to-existing/${transferToId}`,
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    transferDonorConnectToCenter: (transferFromId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ITransferResponse> => {
        let options = {
            url: `${__API__}/donor-connect/${transferFromId}/transfer-to-center/${centerId}`,
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    sendConfirmEmail: (donorEmail: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/send-confirm-email`,
            data: {
                donorEmail
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    getDuplicates: (registrationId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDuplicateListResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${registrationId}/duplicates`,
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getCenterContacts: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterContactsResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/center-contacts/${centerId}`,
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    downloadCenterContacts: (centerId: number): any => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: `${__API__}/donor-connect/center-contacts/${centerId}?csv=true`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getById: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let options: IGet = {
            url: `${__API__}/donor-intake/${id}`,
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getDonorIntakeLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashCenterLookupDataResponse> => {
        let options: IGet = {
            url: `${__API__}/donor-intake/lookup-data?centerId=${centerId}`,
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    shipJugOnly: (id: number, addressLine1: string, city: string, state: number, postalCode: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-intake/${id}/ship-jug-only`,
            data: {
                addressLine1,
                city,
                state,
                postalCode
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    startPwl: (id: number, addressLine1: string, city: string, state: number, postalCode: string, emailContent: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-intake/${id}/start-pwl`,
            data: {
                addressLine1,
                city,
                state,
                postalCode,
                emailContent
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    validateAddress: (address: string, address2: string, city: string, state: string, postalCode: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IAddressValidationResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-intake/validate-address`,
            data: {
                address,
                address2,
                city,
                state,
                postalCode
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    onHoldStatusReasonChange: (id:number, onHoldStatusReason: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/${id}/change-status-on-hold-reason/${onHoldStatusReason}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    }
}

export const ActionCreators = {
    ...ActionCreatorsMain,
    ...ActionCreatorsIlda,
    ...ActionCreatorsReports,
    ...ActionCreatorsLanguage,
    ...ActionCreatorsSelfServeReconciliation,
    ...ActionCreatorsDonorConnectIncidenReports,
};

export {
    IIldaListResponse, IIldaCountResponse, IIldaLogListResponse, IIldaLogResponse, IIldaLookupDataResponse, IIldaRegistrationResponse, IIldaUploadedFilesListResponse, IIldaUserListResponse,
    IDashSelfServeReconciliationCreateResponse, IDashSelfServeReconciliationProcessResponse, IDashSelfServeReconciliationUploadResponse, IIncidentReportLogResponse,
    IIncidentReportResponse,
    IDonorConnectCompletionsReportResponse, IDonorConnectMentorPerformanceResponse, IIncidentReportListResponse, IIncidentReportLookUpResponse, IMentorCompletionsListResponse,
    IVariableReportLookUpResponse, IVariableReportListResponse, IVariableTextResponse
}

export interface IDashState { }

var initialState: IDashState = {};

const createReducer = (initialState: IDashState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {};

export const Reducer = createReducer(initialState, handlers);
